import React from "react";
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';
import DateRange from '../selectComponents/DateRange';
import DateFilter from '../selectComponents/DateFilter';
import HourFilter from '../selectComponents/HourFilter';
import SmrySelect from '../selectComponents/SmrySelect';
import WxVariableSelect from '../selectComponents/WxVariableSelect';
import InfoButton from '../selectComponents/InfoButton';

const variableChoices = [
  {value: 'temp',  label: 'Temperature'},
  {value: 'dwpt',  label: 'Dewpoint'},
  {value: 'wchill', label: 'Wind Chill'},
  {value: 'htindx', label: 'Heat Index'},
  {value: 'wetb',  label: 'Wet Bulb Temperature'},
  {value: 'pcpn',  label: 'Precipitation'},
  {value: 'wspd',  label: 'Wind Speed'},
  {value: 'wgust', label: 'Wind Gust'},
  {value: 'rhum',  label: 'Relative Humidity'},
  {value: 'pres',  label: 'Station Pressure'},
  {value: 'slp',   label: 'Sea Level Pressure'},
  {value: 'altp',  label: 'Altimeter Setting'},
  {value: 'wx',    label: 'Present Weather'},
  {value: 'srad',  label: 'Solar Radiation'},
]

const smryChoices = [
  {value: 'cnthrs', label: 'Number of hours'},
  {value: 'pcthrs', label: 'Percent of hours'},
  {value: 'cntdys', label: 'Number of days'},
  {value: 'max', label: 'Highest'},
  {value: 'min', label: 'Lowest'},
  {value: 'mean', label: 'Mean'},
  {value: 'sum', label: 'Sum'},
]

export default function MonsmryOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton } = props;

  return (
    <>
      <DateRange 
        userParams={userParams}
        setUserParams={setUserParams}
      />
      <DateFilter
        userParams={userParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <HourFilter 
        userParams={userParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <SmrySelect 
        userParams={userParams}
        setUserParams={setUserParams} 
        selectOptions={selectOptions} 
        handleChange={handleChange} 
        setDisableGoButton={setDisableGoButton} 
        smryChoices={smryChoices} 
        variableChoices={variableChoices} 
      />
      { userParams.variable === "wx" &&
        <>
          <WxVariableSelect
              userParams={userParams}
              setUserParams={setUserParams} 
          />
          <br />
        </>
      }
      <FieldsetBox component="fieldset" sx={{ mt:1 }}>
        <LegendStyled>Allowable missing</LegendStyled>
        <Stack direction="row" spacing={0}>
          <Typography variant="body2" sx={{ m: 1, ml: 0 }}>
            Allowable percent missing data in a month:
          </Typography>
          <TextField
            name="allowMissing"
            placeholder="Percent"
            label="Percent"
            value={userParams.allowMissing}
            onChange={handleChange}
            sx={{ width: '8ch', m: 0, mr: 1 }}
          /> 
          <InfoButton
				    infoFor="allowMissing"
				    edge={false}
			    />
        </Stack>
      </FieldsetBox>
     </>
  )
}
